export default "__VITE_ASSET__m5cEbgZ5__"